module.exports = __webpack_public_path__ + "img/mz.0fad0ca1.svg";